import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { IBaseTable } from 'projects/registro-personas-empresas/src/app/shared/util/base-table.util';
import { Laboratorio } from '../../entity-laboratorios/laboratorios.model';
import { MatDialog } from '@angular/material/dialog';
import { RegistroActividadLaboratorioFormContainerComponent } from '../registro-actividad-laboratorio-form-container/registro-actividad-laboratorio-form-container.component';
import { Store } from '@ngrx/store';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { entityLaboratoriosDeleteRequest } from '../../entity-laboratorios/laboratorios.actions';
import { ConfirmDialogComponent } from 'projects/registro-personas-empresas/src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'rpe-registro-actividad-laboratorio-tabs-form',
  templateUrl: './registro-actividad-laboratorio-tabs-form.component.html',
  styleUrls: ['./registro-actividad-laboratorio-tabs-form.component.scss']
})
export class RegistroActividadLaboratorioTabsFormComponent {
  initial: boolean = false;

  @Input() set actividadLaboratorioTabsInput({
    data,
    edit
  }: {
    data: Laboratorio[];
    edit: boolean;
  }) {
    this.baseTableOptions = {
      ...this.baseTableOptions,
      dataSource: data
    };

    if (data.length === 0 && !edit && !this.initial) {
      this.onAdd();
    }

    this.initial = true;
  }

  @Output() showLabEvent: EventEmitter<boolean> = new EventEmitter<boolean>(
    false
  );

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  baseTableOptions: IBaseTable<Laboratorio> = {
    dataSource: [],
    columns: [
      {
        caption: 'Número',
        field: {
          key: 'id'
        }
      },
      {
        caption: 'Nombre',
        field: {
          key: 'nombre'
        }
      }
    ],
    actions: [
      {
        name: 'Editar',
        icon: '',
        hide: () => {
          return true;
        },
        action: (element: Laboratorio) => {
          this.dialog.open(RegistroActividadLaboratorioFormContainerComponent, {
            data: {
              laboratorio: element
            },
            height: '90vh',
            width: '900px'
          });
        }
      },
      {
        name: 'Borrar',
        icon: '',
        hide: () => {
          return true;
        },
        action: ($event: Laboratorio) => {
          this.deleteLaboratorio($event);
        }
      }
    ]
  };

  constructor(private dialog: MatDialog, private store: Store<State>) {}

  onCancel() {
    this.showLabEvent.emit(false);
  }

  deleteLaboratorio($event: Laboratorio): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Eliminar laboratorio',
        contentText: `¿Está seguro que desea eliminar el laboratorio?`,
        submitText: 'Eliminar',
        cancelText: 'Cancelar',
        cancelColor: 'primary'
      }
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(
          entityLaboratoriosDeleteRequest({
            item: $event
          })
        );
      }
    });
  }

  onAdd() {
    this.dialog.open(RegistroActividadLaboratorioFormContainerComponent, {
      data: {
        laboratorio: null
      },
      height: '90vh',
      width: '900px'
    });
  }
}
